export default "__VITE_ASSET__BVJdeg0R__"